import React, { ReactNode }                         from "react";
import { connect }                                  from "react-redux";
import { Tab }                                      from "semantic-ui-react";
import Customer                                     from "../../../domain/customer/Customer";
import MenuType                                     from "../../../domain/menu/MenuType";
import { ResKaState }                               from "../../../index";
import Breadcrumbs                                  from "../../components/common/Breadcrunmbs";
import BackHistoryButton                            from "../../components/common/BuckHistoryButton";
import TopSection                                   from "../../components/common/layout/TopSection";
import CustomerRecordDateButton                     from "../../components/customer/record/CustomerRecordDateButton";
import CustomerRecordForm                           from "../../components/customer/record/CustomerRecordForm";
import CustomerRecordUpdateButton                   from "../../components/customer/record/CustomerRecordUpdateButton";
import ResKaBaseContainer, { BaseProps, BaseState } from "../ResKaBaseContainer";

interface Props extends BaseProps {
  customer: Customer;
}

class CustomerRecordEditContainer extends ResKaBaseContainer<Props, BaseState> {
  constructor(props: Props) {
    const state: BaseState = {
      headerTitle: "顧客記録作成",
      menuType: MenuType.CUSTOMER,
    };
    super(props, state);
  }

  protected componentDidMountInternal(): void {
  }

  protected renderInternal(): ReactNode {
    const {customer} = this.props;
    return (
      <>
        <TopSection>
          <Breadcrumbs breadcrumbs={
            [
              {
                title: "顧客一覧",
                path: "/customers"
              },
              {
                title: "顧客記録一覧",
                path: "/customer/records"
              },
              {
                title: "顧客記録編集",
                path: "/customer/record/edit",
              },
            ]
          }/>
        </TopSection>

        <TopSection>
          <CustomerRecordUpdateButton/>
          <BackHistoryButton path="/customer/records"/>
        </TopSection>

        <TopSection>
          <CustomerRecordDateButton/>
        </TopSection>

        <Tab
          panes={ [
            {
              menuItem: `${ customer.detail.name.lastName.value } ${ customer.detail.name.firstName.value }`,
              render: () => (
                <CustomerRecordForm/>
              )
            }
          ] }
        />
      </>
    );
  }

}

const mapStateToProps = (state: ResKaState) => ({
  fetchStatus: state.fetchStatus,
  customer: state.customer,
});

export default connect(mapStateToProps)(CustomerRecordEditContainer);